var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
function SvgUsers16(_a, svgRef) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", className: "YdsSvgIcon-root ".concat(className !== null && className !== void 0 ? className : ''), width: '1rem', height: '1rem', fill: "currentColor", focusable: "false", "aria-hidden": "true", ref: svgRef }, props),
        React.createElement("g", { id: "users_16_svg__users_16" },
            React.createElement("g", { id: "users_16_svg__users_16-2", "data-name": "users_16" },
                React.createElement("path", { id: "users_16_svg__Pfad_4378", "data-name": "Pfad 4378", d: "M0 0h16v16H0Z", fill: "none" }),
                React.createElement("path", { id: "users_16_svg__Vereinigungsmenge_179", "data-name": "Vereinigungsmenge 179", d: "M-2762-2241a13.592 13.592 0 0 1 .422-2.626 25.746 25.746 0 0 1 3.087-1.617l-.051-.385a4.219 4.219 0 0 1-1.762-3.482 2.71 2.71 0 0 1 2.823-2.889 2.857 2.857 0 0 1 2.091.844 2.565 2.565 0 0 1 .733 2.044 4.214 4.214 0 0 1-1.762 3.481l-.041.314s2.229 1.43 2.911 1.783A11.909 11.909 0 0 1-2753-2241Zm15-2h-5.136a5.329 5.329 0 0 0-.351-1.534c-.389-.226-1.35-.9-2.088-1.425a21.815 21.815 0 0 1 2.392-1.285l-.048-.385a4.3 4.3 0 0 1-1.3-1.668 4.635 4.635 0 0 0 .058-.814 2.815 2.815 0 0 0-.368-1.648 2.57 2.57 0 0 1 2.612-2.24h.047a2.628 2.628 0 0 1 1.926.844 2.661 2.661 0 0 1 .692 2.043 4.315 4.315 0 0 1-1.664 3.482l-.038.313.031.021c.495.336 2.155 1.455 2.716 1.762A12.275 12.275 0 0 1-2747-2243Z", transform: "translate(2762 2255)" })))));
}
var ForwardRef = React.forwardRef(SvgUsers16);
export default ForwardRef;
